import React, {
  useRef,
  useCallback,
  useEffect,
  useState,
  ChangeEvent,
} from 'react';
import Grid from '@material-ui/core/Grid';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { FiCamera } from 'react-icons/fi';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { RiCloseLine } from 'react-icons/ri';
import { FaRegTrashAlt } from 'react-icons/fa';

import api from '../../../../../../../../../services/api';

import no_image from '../../../../../../../../../assets/no_image.png';
import InputLogged from '../../../../../../../../../components/InputLogged';
import Select from '../../../../../../../../../components/Select';

import { useSimpleProduct } from '../../../../../../../../../hooks/newSimpleProduct';
import { useRegisterAdded } from '../../../../../../../../../hooks/registerAdded';
import { useToast } from '../../../../../../../../../hooks/toast';
import { useAuth } from '../../../../../../../../../hooks/auth';
import newComplemento from '../../../../../../../../../services/newComplemento';

import {
  TabWrapper,
  AddButton,
  NewImg,
  LabelWrapper,
  FormWrapper,
  ButtonAction,
  QtdItemContainer,
  TrashBtnWrapper,
} from '../../../../../drawer_styles';
import { SubmitButtonWrapper, ModalWrapper } from '../../../../../../styles';
import material_styles from '../../../../../drawer_styles/material_styles';
import tipos from '../../../../../../../utils/tiposGrupo';

interface OptionType {
  id: string;
  value: string;
  label: string;
}

interface QtdComplementos {
  index: number;
  index_qtdItens: number;
}

interface ItemComplementoType {
  codigo_complemento?: string;
  descricao: string;
  tipo: number;
  preco: number;
  imagem?: File;
  produto_id?: number;
  index_complemento: number;
  qtd_min: number;
  qtd_max: number;
}

interface ImageType {
  img_item?: File;
}

interface ComplementosProps {
  grupo_produto_id?: number;
}

interface QtdItem {
  qtdMin: number;
  qtdMax: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '70%',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #757575',
      borderRadius: '6px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 0, 3),
    },
  }),
);

const Complementos: React.FC<ComplementosProps> = ({ grupo_produto_id }) => {
  const [qtdComplementos, setQtdComplementos] = useState<QtdComplementos[]>([
    { index: 0, index_qtdItens: 0 },
  ]);
  const [qtdItem, setQtdItem] = useState<QtdItem[]>([{ qtdMin: 0, qtdMax: 0 }]);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmacaoModal, setConfirmacaoModal] = useState(false);
  const [materiasPrimas, setMateriasPrimas] = useState<OptionType[]>([]);
  const [itensImg, setItensImg] = useState<ImageType[]>([]);

  const {
    createItensComplemento,
    handleSetDisponibilidadeReleased,
    handleSetComplementoDrawerOpen,
    handleSetItensComplementoReleased,
    handleAbortNewComplemento,
    complemento,
    cleanData,
  } = useSimpleProduct();
  const { handleSetComplementoUpdated } = useRegisterAdded();
  const { addToast } = useToast();
  const { user } = useAuth();

  const formRef = useRef<FormHandles>(null);
  const classes = material_styles();
  const modalClasses = useStyles();

  useEffect(() => {
    async function loadMateriasPrimas(): Promise<void> {
      const response = await api.get(`/produto/tipo/${2}`);

      const optionItems: OptionType[] = [];

      response.data.map((item: any) => {
        const option = {
          id: item.id,
          value: item.id,
          label: item.descricao,
        };

        optionItems.push(option);
      });

      setMateriasPrimas([...optionItems]);
    }

    loadMateriasPrimas();
  }, []);

  const handleToggleModal = useCallback((value: boolean) => {
    setModalOpen(value);
  }, []);

  const handleRemoveItem = useCallback(
    (index: number) => {
      const newQtd = [...qtdComplementos];
      const newItensQtd = [...qtdItem];

      if (newQtd.length - 1 === 0) {
        addToast({
          type: 'error',
          title: 'Exclusão negada',
          description: 'Seu grupo de complementos deve ter pelo menos um item.',
        });

        return;
      }

      newItensQtd.splice(index, 1);
      newQtd.splice(index, 1);

      for (let i = 0; i < newQtd.length; i += 1) newQtd[i].index_qtdItens = i;

      setQtdComplementos([...newQtd]);
      setQtdItem([...newItensQtd]);
    },
    [qtdComplementos, qtdItem, addToast],
  );

  const handleImgChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, item_index: number) => {
      if (e.target.files) {
        const itensStored: ImageType[] = itensImg;

        itensStored[item_index] = { img_item: e.target.files[0] };

        setItensImg([...itensStored]);
      }
    },
    [itensImg],
  );

  const handleAddComplemento = useCallback(() => {
    setQtdComplementos([
      ...qtdComplementos,
      {
        index: qtdComplementos[qtdComplementos.length - 1].index + 1,
        index_qtdItens:
          qtdComplementos[qtdComplementos.length - 1].index_qtdItens + 1,
      },
    ]);
    setQtdItem([...qtdItem, { qtdMin: 0, qtdMax: 0 }]);
  }, [qtdComplementos, qtdItem]);

  const handleSetQtd = useCallback(
    (input: string, operacao: string, index: number) => {
      const newQtdItem = [...qtdItem];

      if (operacao === 'increment') {
        input === 'qtdMin'
          ? (newQtdItem[index].qtdMin = newQtdItem[index].qtdMin + 1)
          : (newQtdItem[index].qtdMax = newQtdItem[index].qtdMax + 1);
      } else if (operacao === 'decrement') {
        if (input === 'qtdMin') {
          if (newQtdItem[index].qtdMin - 1 < 0) return;

          newQtdItem[index].qtdMin = newQtdItem[index].qtdMin - 1;
        }

        if (input === 'qtdMax') {
          if (newQtdItem[index].qtdMax - 1 < 0) return;

          newQtdItem[index].qtdMax = newQtdItem[index].qtdMax - 1;
        }
      }

      setQtdItem([...newQtdItem]);
    },
    [qtdItem],
  );

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        const keys = Object.entries(data);
        const itemType: ItemComplementoType[] = [];

        for (let i = 0; i < qtdComplementos.length; i += 1) {
          const index = i + i * 3;

          const descricao = `${keys[index][1]}`;
          const produto_id = keys[index + 1][1]
            ? Number(keys[index + 1][1])
            : undefined;
          const preco = Number(keys[index + 2][1]);
          const codigo_complemento = `${keys[index + 3][1]}`;

          if (!descricao) {
            addToast({
              type: 'error',
              title: `Não é possível cadastrar itens sem nome.`,
            });

            return;
          }

          if (!produto_id && !confirmacaoModal) {
            setModalOpen(true);
            return;
          }

          // if (codigo_complemento) {
          //   const response = await api.get(
          //     `/complemento/item/${codigo_complemento}`,
          //   );

          //   if (response.data) {
          //     addToast({
          //       type: 'error',
          //       title: `Já existe um item cadastrado com o código ${codigo_complemento}`,
          //     });

          //     return;
          //   }
          // }

          if (qtdItem[i].qtdMin > qtdItem[i].qtdMax) {
            addToast({
              type: 'error',
              title: 'Quantidade inválida.',
              description: `A quantidade mínima do item ${descricao} deve ser maior que a quantidade máxima.`,
            });

            return;
          }

          const objectType: ItemComplementoType = {
            descricao,
            produto_id,
            preco,
            codigo_complemento,
            imagem: itensImg[i] ? itensImg[i].img_item : undefined,
            tipo: Number(tipos.SIMPLES),
            index_complemento: complemento.length - 1,
            qtd_min: qtdItem[i].qtdMin,
            qtd_max: qtdItem[i].qtdMax,
          };

          itemType.push(objectType);
        }

        if (grupo_produto_id) {
          await newComplemento(
            complemento,
            itemType,
            grupo_produto_id,
            user.empresa_id,
          );
          addToast({
            type: 'success',
            title: 'Grupo de Complementos e Itens cadastrados.',
          });
          cleanData();
          handleSetComplementoUpdated(true);
          handleSetComplementoDrawerOpen(false);

          return;
        }

        createItensComplemento([...itemType]);

        handleSetDisponibilidadeReleased(true);
        handleSetComplementoDrawerOpen(false);
        handleSetItensComplementoReleased(false);

        addToast({
          type: 'success',
          title: 'Grupo de Complementos e Itens adicionados',
        });
        setConfirmacaoModal(false);
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao criar um novo complemento',
          description: err.response?.data.message,
        });
      }
    },
    [
      confirmacaoModal,
      qtdComplementos,
      itensImg,
      createItensComplemento,
      handleSetDisponibilidadeReleased,
      handleSetComplementoDrawerOpen,
      handleSetItensComplementoReleased,
      handleSetComplementoUpdated,
      addToast,
      qtdItem,
      cleanData,
      grupo_produto_id,
      complemento,
      user,
    ],
  );

  return (
    <TabWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.noPaddingBot}>
          <AddButton type="button" onClick={handleAddComplemento}>
            + Adicionar Complemento
          </AddButton>
        </Grid>

        <Grid item xs={12}>
          <Form ref={formRef} onSubmit={handleSubmit}>
            {qtdComplementos.map((item) => (
              <FormWrapper className="form_item" key={item.index}>
                <Grid container spacing={3}>
                  <Grid item xs={3}>
                    <NewImg>
                      <img
                        src={
                          itensImg[item.index]
                            ? URL.createObjectURL(itensImg[item.index].img_item)
                            : no_image
                        }
                        alt="Item Complemento"
                      />

                      <label htmlFor={`complemento_img${item.index}`}>
                        <FiCamera size={20} />
                        <input
                          type="file"
                          id={`complemento_img${item.index}`}
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            handleImgChange(e, item.index)
                          }
                        />
                      </label>
                    </NewImg>
                  </Grid>

                  <Grid item xs={9}>
                    <Grid container spacing={1}>
                      <Grid item xs={6} className={classes.noPaddingTop}>
                        <LabelWrapper>
                          <span>Nome do complemento</span>
                        </LabelWrapper>
                        <InputLogged
                          name={`descricao${item.index}`}
                          placeholder="Digite o nome"
                        />
                      </Grid>

                      <Grid item xs={5} className={classes.noPaddingTop}>
                        <LabelWrapper>
                          <span>Matéria Prima</span>
                        </LabelWrapper>
                        <Select
                          name={`produto_id${item.index}`}
                          placeholder="Matéria prima"
                          options={materiasPrimas}
                        />
                      </Grid>

                      <Grid item xs={1} className={classes.noPaddingTop}>
                        <TrashBtnWrapper>
                          <button
                            type="button"
                            onClick={() => handleRemoveItem(item.index)}
                          >
                            <FaRegTrashAlt size={20} />
                          </button>
                        </TrashBtnWrapper>
                      </Grid>

                      <Grid item xs={3} className={classes.noPaddingTop}>
                        <LabelWrapper>
                          <span>Preço</span>
                        </LabelWrapper>
                        <InputLogged
                          name={`preco${item.index}`}
                          type="number"
                          placeholder="Preco"
                          step=".001"
                        />
                      </Grid>

                      <Grid item xs={3} className={classes.noPaddingTop}>
                        <LabelWrapper>
                          <span>Código PDV</span>
                        </LabelWrapper>
                        <InputLogged
                          name={`codigo_complemento${item.index}`}
                          placeholder="Código"
                        />
                      </Grid>

                      <Grid item xs={3} className={classes.qtdWrapperStyle}>
                        <QtdItemContainer>
                          <div className="control-wrapper">
                            <span>Mínimo</span>

                            <div>
                              <button
                                type="button"
                                className="decrement"
                                onClick={() =>
                                  handleSetQtd(
                                    'qtdMin',
                                    'decrement',
                                    item.index_qtdItens,
                                  )
                                }
                              >
                                -
                              </button>

                              <input
                                type="number"
                                min="0"
                                readOnly
                                value={qtdItem[item.index_qtdItens].qtdMin}
                              />

                              <button
                                type="button"
                                className="increment"
                                onClick={() =>
                                  handleSetQtd(
                                    'qtdMin',
                                    'increment',
                                    item.index_qtdItens,
                                  )
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </QtdItemContainer>
                      </Grid>

                      <Grid item xs={3} className={classes.qtdWrapperStyle}>
                        <QtdItemContainer>
                          <div className="control-wrapper">
                            <span>Máximo</span>

                            <div>
                              <button
                                type="button"
                                className="decrement"
                                onClick={() =>
                                  handleSetQtd(
                                    'qtdMax',
                                    'decrement',
                                    item.index_qtdItens,
                                  )
                                }
                              >
                                -
                              </button>

                              <input
                                type="number"
                                min="0"
                                readOnly
                                value={qtdItem[item.index_qtdItens].qtdMax}
                              />

                              <button
                                type="button"
                                className="increment"
                                onClick={() =>
                                  handleSetQtd(
                                    'qtdMax',
                                    'increment',
                                    item.index_qtdItens,
                                  )
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </QtdItemContainer>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </FormWrapper>
            ))}

            <Grid item xs={12} className={classes.noPaddingBot}>
              <SubmitButtonWrapper>
                <ButtonAction
                  type="button"
                  className="cancel"
                  onClick={() => {
                    handleSetComplementoDrawerOpen(false);
                    handleAbortNewComplemento();
                  }}
                >
                  Cancelar
                </ButtonAction>

                <ButtonAction type="submit" className="submit">
                  Continuar
                </ButtonAction>
              </SubmitButtonWrapper>
            </Grid>
          </Form>
        </Grid>
      </Grid>

      <Modal
        className={modalClasses.modal}
        open={modalOpen}
        onClose={() => handleToggleModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalOpen}>
          <ModalWrapper>
            <div className="header">
              <h1>Confirmação</h1>

              <button type="button" onClick={() => handleToggleModal(false)}>
                <RiCloseLine size={30} />
              </button>
            </div>

            <div className="description">
              <span>
                Complementos sem matéria prima não terão seu estoque controlado.
                Deseja continuar?
              </span>
            </div>

            <div className="btnActions">
              <button
                type="button"
                className="confirm"
                onClick={() => {
                  setConfirmacaoModal(true);
                  handleToggleModal(false);
                  setTimeout(() => formRef.current?.submitForm(), 0);
                }}
              >
                Confirmar
              </button>

              <button
                type="button"
                className="cancel"
                onClick={() => handleToggleModal(false)}
              >
                Cancelar
              </button>
            </div>
          </ModalWrapper>
        </Fade>
      </Modal>
    </TabWrapper>
  );
};

export default Complementos;
